<!------------------------------------------------------------->
<ng-template #searchSuggestionstemp>
  <div class="search-suggestions">
    <div class="container d-flex flex-column align-items-start p-3 shadow rounded" style="background-color: var(--white);"
      (clickOutside)="searchSuggestions = []" *ngIf="searchSuggestions?.length">
      <ng-container *ngFor="let entry of searchSuggestions">
        @if(entry.type == 'company'){
          <button class="t-btn w-100" style="text-align: left;  line-height: 1.3;" (click)="openSuggestionText(entry.name)" >
            {{ entry.name }} ( <b>Company</b> )
          </button>

        }@else{
          <button class="t-btn w-100" style="text-align: left;  line-height: 1.3;" (click)="openSuggestionText(entry.name)" >
            {{ entry.name }} ( <b>{{ entry.type == "type" ? ("Sub Category:" + entry.parentCategoryName  )  : entry.type == "cat" ? "Category" : "Subcategory"
              }}</b> )
          </button>
          
          <ng-container *ngIf="entry?.types">
            <button class="t-btn w-100" style="text-align: left;  line-height: 1.3;" *ngFor="let subTypes of entry?.types"
              (click)="openSuggestionText(subTypes.name)">{{ subTypes.name }} (<b>Type</b>)</button>
          </ng-container>
          <ng-container *ngIf="entry?.subcats">
            <ng-container *ngFor="let subEntry of entry?.subcats">
              <button class="t-btn w-100" style="text-align: left; line-height: 1.3;"
                (click)="openSuggestionText(subEntry.name)">{{ subEntry.name }} (<b>Subcategory</b>)</button>
              <ng-container *ngIf="subEntry?.types">
                <button class="t-btn w-100" style="text-align: left; line-height: 1.3;" *ngFor="let subTypes of subEntry?.types"
                  (click)="openSuggestionText(subTypes.name)">{{ subTypes.name }} (<b>Type</b>)</button>
              </ng-container>
            </ng-container>
          </ng-container>

        }
     
      </ng-container>
    </div>
  </div>
</ng-template>
<!------------------------------------------------------------->

<div id="wrapper">
  <div class="nav-map" *ngIf="withOption">
    @if(isOnMobile){
    <div class="top-wrapper">
      <div class="position-relative">
        <input [(ngModel)]="params.search" class="form-control" [ngModelOptions]="{ standalone: true }"
          placeholder="Input Keyword" (keyup.enter)="geocodePostalCode()"  (keydown)="getSearchSuggestions($event)" />

        <div class="position-absolute" style="top: calc(100%); width: 100vw;">
          <div *ngTemplateOutlet="searchSuggestionstemp"></div>
        </div>
      </div>
      <div>
        <button class="search" (click)="geocodePostalCode()" id="btnSearchGmap">
          <i class="fa-solid fa-search"></i>
        </button>
      </div>

    </div>

    }@else{

    <div class="position-relative">
      <label for="">Search Name</label>
      <input [(ngModel)]="params.search" class="form-control" [ngModelOptions]="{ standalone: true }"
        placeholder="Input Keyword" (keyup.enter)="geocodePostalCode()"   (keydown)="getSearchSuggestions($event)"/>
        <div class="position-absolute w-100" style="top: calc(100%)">
          <div *ngTemplateOutlet="searchSuggestionstemp"></div>
        </div>
    </div>
    <div>
      <label for="">Postal</label>
      <input [(ngModel)]="params.postalCode" class="form-control" ngDefaultControl placeholder="Enter Postalcode" />
    </div>
    <div>
      <label for="">Radius</label>
      <select class="form-control form-select" (change)="handleZoom()" [(ngModel)]="params.radius">
        <option value="0" selected disabled>Radius</option>
        <option *ngFor="let radius of [0.2, 1, 2, 5, 10, 20, 'All']" [value]="radius">
          {{ radius == 'All' ? 'All' : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
      </select>
    </div>
    <div>
      <button class="search" (click)="geocodePostalCode()" id="btnSearchGmap">
        <i class="fa-solid fa-search"></i>
      </button>
    </div>


    }


  </div>

  <!-- Start of Selection -->
  <!-- <button class="btn btn-secondary w-100 mb-2 d-block d-md-none" (click)="showMap = !showMap" *ngIf="isOnMobile">
    <i [ngClass]="showMap ? 'fa-solid fa-chevron-up' : 'fa-solid fa-chevron-down'"></i>
    {{ showMap ? 'Hide Maps' : 'Show Maps' }}
  </button> -->


  <div class="map-params my-2" [ngClass]="{ 'd-none d-md-block': !showMap }" *ngIf="isOnMobile">
    <div>
      <label for="">Postal</label>
      <input [(ngModel)]="params.postalCode" class="form-control" ngDefaultControl placeholder="Enter Postalcode" />
    </div>
    <div>
      <label for="">Radius</label>
      <select class="form-control form-select" (change)="handleZoom()" [(ngModel)]="params.radius">
        <option value="0" selected disabled>Radius</option>
        <option *ngFor="let radius of [0.2, 1, 2, 5, 10, 20, 'All']" [value]="radius">
          {{ radius == 'All' ? 'All' : radius < 1 ? radius * 1000 + "m" : radius + "km" }} </option>
      </select>
    </div>
  </div>



  <!-- End of Selection -->

  <!-- Start of Selection -->
  <!-- Start of Selection -->

  <!-- <div id="map" [ngClass]="{ 'd-none d-md-block': !showMap }"></div> -->
</div>